import React, { useContext, useEffect, useId, useState } from "react";
import { AuthContext } from "../../context/authContext";
import SidebarComponent from "../../components/dashboard/Sidebar";
import Loader from "../../components/Loader";
import axios from "axios";
import { BASE_URL } from "../../components/BaseUrl";
import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

const UserPage = () => {
  const { id } = useParams();
  const { admin } = useContext(AuthContext);
  const [user, setUser] = useState(null);
  const [userInvestments, setUserInvestments] = useState(null);
  const [name, setName] = useState(user?.name);
  const [phone, setPhone] = useState(user?.phone);
  const [state, setState] = useState(user?.state);
  const [deposits, setDeposits] = useState(user?.deposits);
  const [managementFee, setManagementFee] = useState(user?.managementFee);
  const [activeInvestments, setActiveInvestments] = useState(
    user?.activeInvestments
  );
  const [withdrawals, setWithdrawals] = useState(user?.withdrawals);
  const [deposited, setDeposited] = useState(user?.deposited);
  const [withdrawn, setWithdrawn] = useState(user?.withdrawn);
  const [balance, setBalance] = useState(user?.balance);
  const [verification, setVerification] = useState(user?.verified);
  const [earnings, setEarnings] = useState(user?.earnings);
  const [country, setCountry] = useState(user?.country);
  const [tier, setTier] = useState(user?._type);
  const [investmentEarnings, setInvestmentEarnings] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const mapId = useId();

  async function updateDetails(
    userName,
    userPhone,
    userState,
    userCountry,
    userDeposits,
    userDeposited,
    userWithdrawals,
    userWithdrawn,
    userBalance,
    userActiveInvestments,
    userVerification,
    userEarnings,
    userId,
    userTier,
    managementFee
  ) {
    try {
      setLoading(true);
      const res = await axios.post(`${BASE_URL}/admin-auth/update-user`, {
        name: userName,
        country: userCountry,
        state: userState,
        phone: userPhone,
        deposits: userDeposits,
        deposited: userDeposited,
        balance: userBalance,
        withdrawals: userWithdrawals,
        withdrawn: userWithdrawn,
        activeInvestments: userActiveInvestments,
        verification: userVerification,
        earnings: userEarnings,
        id: userId,
        _type: userTier,
        managementFee,
      });
      if (res.data.status === "success") {
        setSuccess(true);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setSuccess(false);
      setLoading(false);
    }
  }

  async function updateUserEarnings(investmentId, earnings) {
    try {
      setInvestmentEarnings((prev) => ({
        ...prev,
        [investmentId]: {
          ...prev.investmentId,
          loading: true,
        },
      }));
      await axios.put(
        `${BASE_URL}/txns/update-investment?investmentId=${investmentId}`,
        {
          earnings: parseInt(earnings),
        }
      );
      setSuccess(true);
      setInvestmentEarnings((prev) => ({
        ...prev,
        [investmentId]: {
          ...prev.investmentId,
          loading: false,
        },
      }));
    } catch (error) {
      console.log(error);
      setSuccess(false);
    }
  }

  useEffect(() => {
    axios
      .get(`${BASE_URL}/txns/user/${id}`)
      .then((res) => {
        setUser(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${BASE_URL}/txns/investment?id=${id}`)
      .then((res) => {
        setUserInvestments(res.data.data);
        setInvestmentEarnings(
          res.data.data.reduce((acc, investment) => {
            acc[investment._id] = {
              earning: investment.earnings,
              loading: false,
            };
            return acc;
          }, {})
        );
        // setUser(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  return (
    <div>
      <div>
        <Loader />
      </div>
      <div>
        <SidebarComponent user={admin} />
      </div>
      <div className="p-4 sm:ml-64 bg-[#0a0c0f] min-h-screen">
        <div className="p-4 border border-gray-600 border-dashed min-h-screen rounded-lg dark:border-gray-700 mt-20">
          {user && (
            <div>
              <div>
                <h1 className="text-gray-400 text-xl font-medium">Settings</h1>
              </div>
              <form className="md:grid grid-cols-3 gap-10 mt-10">
                <div>
                  <label htmlFor="name" className="text-gray-300 text-sm">
                    Name
                  </label>
                  <input
                    name="name"
                    defaultValue={user.name}
                    onChange={(e) => setName(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="text-gray-300 text-sm">
                    Email
                  </label>
                  <input
                    name="email"
                    defaultValue={user.email}
                    readOnly
                    className="input"
                  />
                </div>
                <div>
                  <label htmlFor="type" className="text-gray-300 text-sm">
                    Tier
                  </label>
                  <input
                    name="type"
                    defaultValue={user._type}
                    onChange={(e) => setTier(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label htmlFor="name" className="text-gray-300 text-sm">
                    Management Fee
                  </label>
                  <input
                    name="name"
                    defaultValue={user.managementFee}
                    onChange={(e) => setManagementFee(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="text-gray-300 text-sm">
                    Phone
                  </label>
                  <input
                    name="phone"
                    defaultValue={user.phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label htmlFor="country" className="text-gray-300 text-sm">
                    Country
                  </label>
                  <input
                    name="country"
                    defaultValue={user.country}
                    onChange={(e) => setCountry(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label htmlFor="state" className="text-gray-300 text-sm">
                    State
                  </label>
                  <input
                    name="state"
                    defaultValue={user.state}
                    onChange={(e) => setState(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label htmlFor="deposits" className="text-gray-300 text-sm">
                    Deposits
                  </label>
                  <input
                    name="state"
                    defaultValue={user.deposits}
                    onChange={(e) => setDeposits(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label
                    htmlFor="withdrawals"
                    className="text-gray-300 text-sm"
                  >
                    Withdrawals
                  </label>
                  <input
                    name="state"
                    defaultValue={user.withdrawals}
                    onChange={(e) => setWithdrawals(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label htmlFor="deposited" className="text-gray-300 text-sm">
                    Deposited
                  </label>
                  <input
                    name="deposited"
                    defaultValue={user.deposited}
                    onChange={(e) => setDeposited(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label htmlFor="withdrawn" className="text-gray-300 text-sm">
                    Withdrawn
                  </label>
                  <input
                    name="withdrawn"
                    defaultValue={user.withdrawn}
                    onChange={(e) => setWithdrawn(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label htmlFor="balance" className="text-gray-300 text-sm">
                    Balance
                  </label>
                  <input
                    name="balance"
                    defaultValue={user.balance}
                    onChange={(e) => setBalance(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label
                    htmlFor="activeInvestments"
                    className="text-gray-300 text-sm"
                  >
                    Active Investemnts
                  </label>
                  <input
                    name="activeInvestments"
                    defaultValue={user.activeInvestments}
                    onChange={(e) => setActiveInvestments(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label
                    htmlFor="verification"
                    className="text-gray-300 text-sm"
                  >
                    Verification Status
                  </label>
                  <input
                    name="verification"
                    defaultValue={user.verified}
                    onChange={(e) => setVerification(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <label htmlFor="earnings" className="text-gray-300 text-sm">
                    Earnings
                  </label>
                  <input
                    name="earnings"
                    defaultValue={user.earnings}
                    onChange={(e) => setEarnings(e.target.value)}
                    className="input"
                  />
                </div>
                <div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      updateDetails(
                        name,
                        phone,
                        state,
                        country,
                        deposits,
                        deposited,
                        withdrawals,
                        withdrawn,
                        balance,
                        activeInvestments,
                        verification,
                        earnings,
                        user._id,
                        tier,
                        managementFee
                      );
                    }}
                    type="submit"
                    className="md:w-1/2 w-full bg-[#b2ffce] px-5 py-2 rounded-md font-medium"
                  >
                    {loading ? (
                      <CircularProgress color="inherit" size="25px" />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
              {userInvestments && userInvestments.length && (
                <div className="mt-12">
                  <h1 className="text-gray-300 text-xl font-semibold mb-3">
                    User Investments
                  </h1>
                  {userInvestments.map((investment, index) => (
                    <div
                      key={mapId + index}
                      className="max-md:py-6 max-md:border-b border-gray-400 my-4"
                    >
                      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 items-center">
                        <h1 className="text-gray-400 font-medium mb-2">
                          Amount:{" "}
                          <span className="text-gray-300">
                            {investment.amount}
                          </span>
                        </h1>
                        <h1 className="text-gray-400 font-medium mb-2">
                          Status:{" "}
                          <span className="text-gray-300">
                            {investment.status}
                          </span>
                        </h1>
                        <h1 className="text-gray-400 font-medium mb-2">
                          Strategy:{" "}
                          <span className="text-gray-300">
                            {investment.pool}
                          </span>
                        </h1>
                        <div>
                          <label
                            htmlFor="investmentEarnings"
                            className="text-gray-300 text-sm"
                          >
                            Earnings
                          </label>
                          <input
                            name="investmentEarnings"
                            value={investmentEarnings[investment._id].earning}
                            className="input"
                            type="text"
                            disabled={investment.status !== "active"}
                            onChange={(e) => {
                              setInvestmentEarnings((prevEarnings) => ({
                                ...prevEarnings,
                                [investment._id]: {
                                  earning: e.target.value,
                                  loading: false,
                                },
                              }));
                            }}
                          />
                        </div>
                        {investment.status === "active" && (
                          <button
                            onClick={() =>
                              updateUserEarnings(
                                investment._id,
                                investmentEarnings[investment._id].earning
                                  ? parseInt(
                                      investmentEarnings[investment._id].earning
                                    )
                                  : 0
                              )
                            }
                            className="lg:w-1/2 lg:mx-auto w-full bg-[#b2ffce] px-5 py-2 rounded-md font-medium"
                          >
                            {investmentEarnings[investment._id].loading ? (
                              <CircularProgress color="inherit" size="25px" />
                            ) : (
                              "Update"
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="bg-[#181b20] px-5 py-9 my-14 rounded-2xl">
                <h1 className="text-gray-300 text-xl font-semibold mb-3">
                  User Referral Stats
                </h1>
                <div className="flex items-center justify-between">
                  <div>
                    <h1 className="text-gray-400 font-medium mb-2">
                      Registered Users
                    </h1>
                    <h1 className="text-gray-400 font-medium mb-2">
                      {user.refers.length}
                    </h1>
                  </div>
                  <div>
                    <h1 className="text-gray-400 font-medium mb-2">
                      Referral Code
                    </h1>
                    <h1 className="text-gray-400 font-medium mb-2">
                      {user.referralCode}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          )}
          {success === true && (
            <Snackbar open={true} autoHideDuration={5000}>
              <Alert severity="success">
                User has been updated successfully
              </Alert>
            </Snackbar>
          )}
          {success === false && (
            <Snackbar open={true} autoHideDuration={5000}>
              <Alert severity="error">
                An error occured, please try again later
              </Alert>
            </Snackbar>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserPage;
